import Vue from 'vue'
import Vuex from 'vuex'
import { storage, db, database, firebase, auth } from "@/firebase";
import { objetoNoVacio } from '../util/utils';

Vue.use(Vuex)

// módulos
import vehiculos from '../modules/vehiculos';

export default new Vuex.Store({
  state: {
    autos:[],
    vehiculosClases:[],
    modelos:[],
    contactos:[],
    redes:[]
  },
  mutations: {
    setStateAutos(state,payload) {
      state.autos = [...payload]
    },
    setStateModels(state,payload){
      state.modelos.length = 0
      state.modelos = [...payload]
    },
    setStateContactos(state,payload){
      state.contactos.length = 0
      state.contactos = [...payload]
    },
    setStateRedes(state,payload){
      state.redes.length = 0
      state.redes = [...payload]
    },
    setStateClases(state, payload){
      state.vehiculosClases = []
      state.vehiculosClases = payload
    }
  },
  actions: {
    async getAutos({ commit,dispatch,  state }){
      // tengo las clases en localStorage?
      if (localStorage.getItem('flota')){
        let clases = JSON.parse(localStorage.getItem('flota'))
        if (clases.length > 0){
          commit('setStateClases', clases)
          return
        }
      }
      // obtengo las clases
      let clasesPeticion = await vehiculos.actions.getClasesVehiculos()
      if (clasesPeticion.resultado == 0){
        commit('setStateClases', [])
        return
      }
      // obtengo los autos
      // comentado el 25-04-2025 por MMURILLO para evitar sobreconsumo en firebase
      // let autosPeticion = await vehiculos.actions.getVehiculos()
      // if (autosPeticion.resultado == 0){
      //   commit('setStateAutos', [])
      //   return
      // }
      if (clasesPeticion.resultado == 0){
        commit('setStateClases', [])
        return
      }
      // me quedo unicamente con las habilitadas
      let habilitadas = clasesPeticion.clases.filter(element => element.available_on_website == true)
      // guardo en localStorage para que no vuelva a consultar a firebase
      localStorage.setItem('flota', JSON.stringify(habilitadas))
      commit('setStateClases', habilitadas)
      // asigno las clases
      // state.vehiculosClases = []
      // state.vehiculosClases = clasesPeticion.clases
      // let vehiFinal = []
      // // obtengo la configuración para cada vehículo
      // for (let id in autosPeticion.vehiculos){
      //   let vehiculo = Object.assign({}, autosPeticion.vehiculos[id])
      //   let clase = state.vehiculosClases.filter(element => element.id == autosPeticion.vehiculos[id].vehicle_class_id)
      //   let features = []
      //   if (clase.length > 0 && objetoNoVacio(clase[0]) && clase[0].hasOwnProperty('features')) features = clase[0].features
      //   let claseActual = Object.assign({}, autosPeticion.vehiculos[id].vehicle_class)
      //   // asigno el resto de las claves
      //   Object.defineProperty(claseActual, 'features', {
      //     value: features.length > 0 ? features : null,
      //     writable: true,
      //     enumerable: false,
      //     configurable: true
      //   })
      //   Object.defineProperty(claseActual, 'dir_asist', {
      //     value: 0,
      //     writable: true,
      //     enumerable: true,
      //     configurable: true
      //   })
      //   Object.defineProperty(claseActual, 'radio', {
      //     value: 0,
      //     writable: true,
      //     enumerable: true,
      //     configurable: true
      //   })
      //   Object.defineProperty(claseActual, 'air_ac', {
      //     value: 0,
      //     writable: true,
      //     enumerable: true,
      //     configurable: true
      //   })
      //   Object.defineProperty(claseActual, 'manual_transmission', {
      //     value: 0,
      //     writable: true,
      //     enumerable: true,
      //     configurable: true
      //   })
      //   Object.defineProperty(claseActual, 'automatic_transmission', {
      //     value: 0,
      //     writable: true,
      //     enumerable: true,
      //     configurable: true
      //   })
      //   Object.defineProperty(claseActual, 'four_doors', {
      //     value: 0,
      //     writable: true,
      //     enumerable: true,
      //     configurable: true
      //   })
      //   Object.defineProperty(claseActual, 'five_doors', {
      //     value: 0,
      //     writable: true,
      //     enumerable: true,
      //     configurable: true
      //   })
      //   // controlo la configuración
      //   if (features != null && features.length > 0){
      //     for (let jd in features){
      //       switch (features[jd].id){
      //         case 1:
      //           claseActual.automatic_transmission = 1
      //           break
      //         case 2:
      //           claseActual.manual_transmission = 1
      //           break
      //         case 3:
      //           claseActual.air_ac = 1
      //           break
      //         case 4:
      //           claseActual.radio  = 1
      //           break
      //         case 5:
      //           claseActual.dir_asist = 1
      //           break
      //         case 6:
      //           claseActual.four_doors = 1
      //           break
      //         case 7:
      //           claseActual.five_doors = 1
      //           break
      //       }
      //     }
      //   }
      //   Object.assign(vehiculo.vehicle_class, claseActual)
      //   Object.defineProperty(vehiculo, 'features', {
      //     value: features,
      //     writable: true,
      //     enumerable: false,
      //     configurable: true
      //   })
      //   vehiFinal.push(vehiculo)
      // }
      // commit('setStateAutos', vehiFinal)
      // dispatch('setModels')
    },
    setModels({ commit,state }){
          //Obtener Modelos
          let modelsCars = []
          //destructuring autos
          state.autos.map(function(car){
            let {vehicle_model, vehicle_class  } = car
            let data = {...vehicle_class, ...vehicle_model }
            if (!data.hasOwnProperty('features')) data.features = car.features
            modelsCars.push(data)
          })

          //filter active autos
          modelsCars = modelsCars.filter(car => car.active === 1 )

          //get models
          let arrayModels = []
          modelsCars.map(function(car){
            let { id } = car

            let model = arrayModels.filter(car => car.id === id )
    
            if(model.length === 0 ){
              arrayModels.push(car)
            }

          })
          
          commit('setStateModels',arrayModels )
    },
    async getContacto({ commit} ){
      try{
        let  contactos = await firebase.database().ref("/configuracion/contactos")
        contactos.once('value').then((dataSnapshot)=>{
          let data = []
          dataSnapshot.forEach(function(childSnapshot){
            var childData = childSnapshot.val()
            Object.assign(childData,{key:childSnapshot.key})
            data.push(childData)
          })

          commit('setStateContactos',data)
        })


        
      }catch(error){
        console.log(error)
      }

    },
    async getRedes({ commit }){
      try{
        let redes = await firebase.database().ref("/configuracion/redes")
        redes.once('value').then((dataSnapshot)=>{
          let data = []
          dataSnapshot.forEach(function(childSnapshot){
            var childData = childSnapshot.val()
            childData = {...childData,key: childData.key }
            data.push(childData)
          })

          commit('setStateRedes',data)
        })
      }catch(error){
        console.log(error)
      }
    }

  },
  modules: {
    vehiculos
  }
})
